import { DynatraceAPI } from './utils/dynatrace/dynatrace';

declare global {
  interface Window {
    skipAlloyAnalyticsLoad?: boolean;
    dynatrace?: DynatraceAPI;
  }
}

window.skipAlloyAnalyticsLoad = false;

import('./bootstrap');

export {};
